const TYPES = {
  APP_RESIZE: 'APP_RESIZE',
};

export default TYPES;
